import { render, staticRenderFns } from "./InfoSupermercado.vue?vue&type=template&id=58ccae4c&scoped=true"
import script from "./InfoSupermercado.vue?vue&type=script&lang=js"
export * from "./InfoSupermercado.vue?vue&type=script&lang=js"
import style0 from "./InfoSupermercado.vue?vue&type=style&index=0&id=58ccae4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ccae4c",
  null
  
)

export default component.exports